module.exports = __webpack_public_path__ + "static/media/Game.d041bd6d.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Projects/Game.JPG
// module id = 791
// module chunks = 0